import { ThemeMode } from '@modules/theme/constants';
import { useThemeStore } from '@modules/theme/store/useThemeStore';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const RemoveFromCollectionIcon = (props: SvgIconProps) => {
  const { mode } = useThemeStore();
  const isLightMode = mode === ThemeMode.LIGHT;

  const getColorFromProps = () => {
    if (!props.sx) {
      return;
    }
    if ('color' in props.sx) {
      return props.sx.color as string;
    }
    return;
  };

  const pathColor = getColorFromProps()
    ? 'currentColor'
    : isLightMode
    ? '#6738C3'
    : '#BFC2FF';

  return (
    <SvgIcon {...props}>
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        color={pathColor}
      >
        <path
          d="M17 21.2759H5C4.45 21.2759 4 20.8259 4 20.2759V8.27588C4 7.72588 3.55 7.27588 3 7.27588C2.45 7.27588 2 7.72588 2 8.27588V21.2759C2 22.3759 2.9 23.2759 4 23.2759H17C17.55 23.2759 18 22.8259 18 22.2759C18 21.7259 17.55 21.2759 17 21.2759ZM20 3.27588H8C6.9 3.27588 6 4.17588 6 5.27588V17.2759C6 18.3759 6.9 19.2759 8 19.2759H20C21.1 19.2759 22 18.3759 22 17.2759V5.27588C22 4.17588 21.1 3.27588 20 3.27588ZM20 13.2759L17.5 11.7759L15 13.2759V5.27588H20V13.2759Z"
          fill={pathColor}
        />
        <path
          d="M2 1.27588L25 24.2759"
          stroke={isLightMode ? '#FCFBFF' : '#292833'}
          stroke-width="2"
        />
        <path d="M1 2.27588L24 25.2759" stroke={pathColor} stroke-width="2" />
      </svg>
    </SvgIcon>
  );
};
